import React from 'react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Modal } from '../../components/ui/Modal';
import { Switch } from '../../components/ui/Switch';
import { EntitySchemaEditor } from './EntitySchemaEditor';

export const FormEditModal = ({
  open,
  onClose,
  formState,
  onFormChange,
  fields,
  onFieldsChange,
  onSubmit,
  saving = false,
  error = '',
  t
}) => (
  <Modal
    open={open}
    onClose={() => {
      if (!saving) {
        onClose();
      }
    }}
    title={t('requestsEditFormTitle')}
    closeDisabled={saving}
    panelClassName="flex max-h-[min(90vh,860px)] max-w-2xl flex-col overflow-hidden"
  >
    <form className="flex min-h-0 flex-1 flex-col space-y-3 text-start" onSubmit={onSubmit}>
      <div className="min-h-0 flex-1 space-y-3 overflow-y-auto">
        <Input
          label={t('requestsFormDisplayName')}
          value={formState.displayName}
          disabled={saving}
          onChange={(event) => onFormChange({ displayName: event.target.value })}
        />
        <div className="rounded-xl border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium text-neutral-950 dark:text-white">{t('requestsFormAuthNeed')}</p>
              <p className="mt-1 text-xs leading-5 text-neutral-500">{t('requestsFormAuthNeedHint')}</p>
            </div>
            <Switch
              checked={formState.authNeed}
              disabled={saving}
              onChange={(checked) => onFormChange({ authNeed: checked })}
              aria-label={t('requestsFormAuthNeed')}
            />
          </div>
        </div>
        <div className="rounded-xl border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium text-neutral-950 dark:text-white">{t('requestsFormIsPrivate')}</p>
              <p className="mt-1 text-xs leading-5 text-neutral-500">{t('requestsFormIsPrivateHint')}</p>
            </div>
            <Switch
              checked={formState.isPrivate}
              disabled={saving}
              onChange={(checked) => onFormChange({ isPrivate: checked })}
              aria-label={t('requestsFormIsPrivate')}
            />
          </div>
        </div>
        <p className="text-sm font-medium text-neutral-950 dark:text-white">{t('requestsEntityFields')}</p>
        <p className="text-xs leading-5 text-neutral-500">{t('requestsEditFormFieldsHint')}</p>
        <EntitySchemaEditor fields={fields} disabled={saving} t={t} onChange={onFieldsChange} />
        {error ? <p className="text-sm text-rose-600 dark:text-rose-300">{error}</p> : null}
      </div>
      <div className="flex flex-wrap justify-end gap-2">
        <Button type="button" variant="secondary" onClick={onClose} disabled={saving}>
          {t('cancel')}
        </Button>
        <Button type="submit" disabled={saving}>
          {saving ? t('requestsUpdatingForm') : t('save')}
        </Button>
      </div>
    </form>
  </Modal>
);
